import React from 'react';
import { ArrowRight } from 'lucide-react';

const CorporateStory = () => {
  return (
    <section className="relative h-[420px] md:h-[520px] overflow-hidden group">
      <img
        src="https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxzb2xhciUyMGZhcm18ZW58MHx8fHwxNzg0MDA2NTcxfDA&ixlib=rb-4.1.0&q=85"
        alt="Corporate Story"
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-[10000ms] group-hover:scale-110"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent" />
      <div className="relative z-10 h-full flex items-center">
        <div className="max-w-[1280px] mx-auto w-full px-4 lg:px-12">
          <div className="max-w-xl text-white">
            <span className="inline-block text-[#a3d859] text-xs font-bold tracking-[4px] mb-4">
              CORPORATE STORY
            </span>
            <h2
              className="text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Join the Renewable Revolution
            </h2>
            <p className="text-white/80 text-lg mb-8">Our Corporate Story</p>
            <a
              href="#story"
              className="inline-flex items-center gap-3 text-white font-bold text-[13px] tracking-wider group/link"
            >
              <span className="w-12 h-12 rounded-full border-2 border-white/60 flex items-center justify-center group-hover/link:bg-[#8ec045] group-hover/link:border-[#8ec045] transition-all">
                <ArrowRight className="w-4 h-4" />
              </span>
              READ THE STORY
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CorporateStory;
